// extracted by mini-css-extract-plugin
export var arrows = "_2r-6";
export var decrementer = "_2r-a";
export var disabled = "_2r-4";
export var error = "_2r-1";
export var hiddenText = "_2r-b";
export var incrementer = "_2r-9";
export var input = "_2r-8";
export var inputWrapper = "_2r-0";
export var leadingIcon = "_2r-c";
export var readonly = "_2r-3";
export var regular = "_2r-7";
export var small = "_2r-5";
export var warning = "_2r-2";